import type { AppKind, LegalKind, Locale } from "../site";
import { AMHARIC_LEGAL_DOCUMENTS } from "./legal.am";
import { ENGLISH_LEGAL_DOCUMENTS } from "./legal.en";
import type { LegalDocument } from "./legal.types";

export const LEGAL_DOCUMENTS: LegalDocument[] = [
  ...ENGLISH_LEGAL_DOCUMENTS,
  ...AMHARIC_LEGAL_DOCUMENTS,
];

export function getLegalDocument(
  locale: Locale,
  app: AppKind,
  kind: LegalKind,
): LegalDocument {
  const document = LEGAL_DOCUMENTS.find(
    (item) => item.locale === locale && item.app === app && item.kind === kind,
  );

  if (!document) {
    throw new Error(`Missing legal document: ${locale}/${app}/${kind}`);
  }

  return document;
}
